import React from 'react';
import Flower from './Flower';

const InnerBranch = ({ 
  direction, 
  type, 
  flowerId,
  subBranch,
  visible = true,
  flowerVisible = true,
  leaf1Visible = true,
  leaf2Visible = true,
  leaf3Visible = true,
  getFlowerColor,
  getFlowerUtterance = () => undefined
}) => {
  if (!visible) return null;
  
  return (
    <div className={`branch ${direction} ${type}`}>
      {/* Inner branch leaves */}
      {leaf1Visible && <div className="leaf leaf1" />}
      {leaf2Visible && <div className="leaf leaf2" />}
      {leaf3Visible && <div className="leaf leaf3" />}
      
      {/* Inner branch flower */}
      {flowerVisible && (
        <Flower
          flowerId={flowerId}
          color={getFlowerColor(flowerId)}
          utterance={getFlowerUtterance(flowerId)}
        />
      )}
      
      {/* Sub-branch if exists */}
      {subBranch && subBranch.visible && (
        <div className={`branch ${subBranch.direction} ${subBranch.type}`}>
          {subBranch.leaf1Visible && <div className="leaf leaf1" />}
          {subBranch.flowerVisible && (
            <Flower
              flowerId={subBranch.flowerId} 
              color={getFlowerColor(subBranch.flowerId)} 
              utterance={getFlowerUtterance(subBranch.flowerId)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default InnerBranch;